import React from 'react';
import { useParams } from 'react-router-dom';
export function RenewalDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  return <div data-id="element-2149">
      <div className="flex justify-between items-center mb-6" data-id="element-2150">
        <h1 className="text-2xl font-bold" data-id="element-2151">Renewal Details</h1>
        <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" data-id="element-2152">
          Process Renewal
        </button>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-2153">
        <div data-id="element-2154">
          <div className="bg-white rounded-lg shadow p-6" data-id="element-2155">
            <h2 className="text-lg font-medium mb-4" data-id="element-2156">Mortgage Information</h2>
            <div className="space-y-3" data-id="element-2157">
              <div data-id="element-2158">
                <p className="text-sm text-neutral-500" data-id="element-2159">Client</p>
                <p className="font-medium" data-id="element-2160">John Doe</p>
              </div>
              <div data-id="element-2161">
                <p className="text-sm text-neutral-500" data-id="element-2162">Mortgage Type</p>
                <p className="font-medium" data-id="element-2163">Fixed Rate Mortgage</p>
              </div>
              <div data-id="element-2164">
                <p className="text-sm text-neutral-500" data-id="element-2165">Mortgage Number</p>
                <p className="font-medium" data-id="element-2166">MTG-12345</p>
              </div>
              <div data-id="element-2167">
                <p className="text-sm text-neutral-500" data-id="element-2168">Current Rate</p>
                <p className="font-medium" data-id="element-2169">3.25%</p>
              </div>
              <div data-id="element-2170">
                <p className="text-sm text-neutral-500" data-id="element-2171">Start Date</p>
                <p className="font-medium" data-id="element-2172">Jan 1, 2023</p>
              </div>
              <div data-id="element-2173">
                <p className="text-sm text-neutral-500" data-id="element-2174">Renewal Date</p>
                <p className="font-medium" data-id="element-2175">Jan 1, 2024</p>
              </div>
            </div>
          </div>
        </div>
        <div data-id="element-2176">
          <div className="bg-white rounded-lg shadow p-6" data-id="element-2177">
            <h2 className="text-lg font-medium mb-4" data-id="element-2178">Renewal Status</h2>
            <div className="space-y-3" data-id="element-2179">
              <div data-id="element-2180">
                <p className="text-sm text-neutral-500" data-id="element-2181">Status</p>
                <p className="font-medium" data-id="element-2182">Pending</p>
              </div>
              <div data-id="element-2183">
                <p className="text-sm text-neutral-500" data-id="element-2184">New Rate</p>
                <p className="font-medium" data-id="element-2185">3.45%</p>
              </div>
              <div data-id="element-2186">
                <p className="text-sm text-neutral-500" data-id="element-2187">Rate Change</p>
                <p className="font-medium text-red-600" data-id="element-2188">+0.20% increase</p>
              </div>
              <div data-id="element-2189">
                <p className="text-sm text-neutral-500" data-id="element-2190">Notification Sent</p>
                <p className="font-medium" data-id="element-2191">Yes - Dec 1, 2023</p>
              </div>
              <div data-id="element-2192">
                <p className="text-sm text-neutral-500" data-id="element-2193">Client Response</p>
                <p className="font-medium" data-id="element-2194">Awaiting</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}